export const enum Icon {
  BOFANG = "#icon-bofang-new", // 播放
  ZANTING = "#icon-zanting-new", // 暂停
  YINLIANG = "#icon-yinliang-new", // 音量有背景
  YINLIANG1 = "#icon-yinliang1-new", // 音量无背景
  ERJI = "#icon-erji-new", // 耳机
  SOUSUO = "#icon-sousuo-new", // 搜索
  XIAZAI = "#icon-xiazai-new", // 下载
  ZHEDIE = "#icon-jiantou-xia-cuxiantiao-new", // 关锁
  KAISUO = "#icon-jiantou-kaisuo", // 开锁
  SHANGYISHOU = "#icon-ziyuanldpi-new", // 上一首
  XIAYISHOU = "#icon-ziyuanldpi1-new", // 下一首
  JINGYIN = "#icon-yinliangjingyinheix-new", // 静音
  LIEBIAO = "#icon-liebiao-new", // 列表
  Dislike = "#icon-xihuan1-new", // 未收藏
  Like = "#icon-xihuan-new", // 收藏
  Support = "#icon-zan-new", // 赞
  XUNHUAN = "#icon-xunhuan-new", // 循环
  LUANXU = "#icon-xunhuan1-new", // 乱序
}
